<app-header></app-header>
<app-messages class="informativo"
  message="Transbank le solicita llenar la siguiente declaración jurada: En virtud de lo dispuesto en la circular 57/2017 de la UAF (Unidad de Análisis FInanciero).">
</app-messages>
<div class="d-flex justify-content-center">
  <img src="assets/images/UAF.png">
</div>
<div class="d-flex justify-content-center">
  <div class="col-md-4">
    <input class="btn-secondary-tbk" type="submit" value="Volver">
  </div>
  <div class="col-md-4">
    <input class="btn-primary-tbk" type="submit" value="Aceptar y guardar">
  </div>
</div>
<app-footer></app-footer>
